export default __webpack_public_path__ + "static/media/letmeask-logo-1.74629641.png";